import { selectAssignment } from '@redux/experiments/selectors/index';
import type { StorefrontPeaceOfMindRetestAssignment } from '@typings/experiments';
import type { State } from 'types/redux';

/**
 * Selector to get the SF PoM Storefront Indicator - Retest experiment assignment
 */
export const storefrontPeaceOfMindRetestSelector = (
	state: State,
): StorefrontPeaceOfMindRetestAssignment => {
	const isPom = state.vendor.vendor?.settings.peaceOfMindEligible;

	if (!isPom) {
		return null;
	}

	return (
		(selectAssignment(state, ['storefrontPeaceOfMindRetest']) as
			| StorefrontPeaceOfMindRetestAssignment
			| undefined) ?? null
	);
};
